import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Flex } from "~/components/Flex";
import { Link as RouterLink } from "react-router-dom";
import { Space } from "~/lib/types";
import { CreateTicketingIntegrationContent } from "~/pages/tickets/components/CreateTicketingIntegration/CreateTicketingIntegrationContent";
import { DialogProps } from "@toolpad/core";
import { AttachIcon } from "~/icons";

export interface CreateTicketIntegrationDialogPayload {
  space: Space;
  redirectTo: string;
  hasIntegrationCreatePermission: boolean;
}

export const CreateTicketIntegrationDialog = ({
  onClose,
  open,
  payload,
}: DialogProps<CreateTicketIntegrationDialogPayload>) => {
  const { space, redirectTo, hasIntegrationCreatePermission } = payload;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 5,
        }}
      >
        <Typography sx={{ display: "flex", alignItems: "center" }} gap={2}>
          <AttachIcon />
          <Typography
            variant="h5"
            sx={{
              textTransform: "uppercase",
              fontWeight: "700",
            }}
          >
            GET STARTED USING TICKETS
          </Typography>
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 4, px: 5 }}>
        <Flex justifyContent="space-around" sx={{ gap: 2 }}>
          <CreateTicketingIntegrationContent />
        </Flex>
      </DialogContent>
      <DialogActions sx={{ px: 5, py: 5, justifyContent: "center" }}>
        <Flex flexDirection="column" gap={1}>
          <Button
            disabled={!hasIntegrationCreatePermission}
            component={RouterLink}
            to={`/space/integrations/add?spaceId=${space.id}&redirectTo=${encodeURIComponent(redirectTo)}#ticketsystems`}
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Add Integration
          </Button>
          {!hasIntegrationCreatePermission && (
            <Typography component="span" sx={{ fontSize: 10 }} color="error">
              You don't have permission to create an integration.
            </Typography>
          )}
        </Flex>
      </DialogActions>
    </Dialog>
  );
};
